import { DASHPASS_STATUS } from '../types/dashpass';
import { EXPENSED_MEALS_STATUS } from '../types/expensed_meal';
var PendoUtil = /** @class */ (function () {
    function PendoUtil() {
        this.initialized = false;
        this.teamAccountId = null;
        this.teamId = null;
        this.consumerId = null;
        this.teamAccountPlan = null;
    }
    PendoUtil.prototype.initializePendo = function (consumerId, currentTeamMember, teamAccount, teamId, teamName, teamAccountPlan) {
        var _a, _b;
        // @ts-ignore
        if (window === null || window === void 0 ? void 0 : window.pendo) {
            // @ts-ignore
            var pendo = window.pendo;
            var hasDashPassForSelectedAccount = ((_a = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.dashPass) === null || _a === void 0 ? void 0 : _a.status) ===
                DASHPASS_STATUS.TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE;
            var hasExpensedMealsForSelectedAccount = ((_b = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.expensedMeals) === null || _b === void 0 ? void 0 : _b.status) === EXPENSED_MEALS_STATUS.ACTIVE;
            if (!this.initialized) {
                pendo.initialize({
                    visitor: {
                        id: consumerId,
                        email: currentTeamMember === null || currentTeamMember === void 0 ? void 0 : currentTeamMember.email,
                    },
                    account: {
                        id: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.id,
                        teamAccountName: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.name,
                        teamId: teamId,
                        teamName: teamName,
                        expensed_meals_active: hasExpensedMealsForSelectedAccount,
                        dashpass_for_work_active: hasDashPassForSelectedAccount,
                        countryCode: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.countryCode,
                        teamAccountPlan: teamAccountPlan,
                    },
                });
            }
            // update metadata new teamAccountId
            if (this.initialized && (teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.id) !== this.teamAccountId) {
                pendo.identify({
                    visitor: {
                        id: consumerId,
                    },
                    account: {
                        id: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.id,
                        teamAccountName: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.name,
                        teamId: teamId,
                        teamName: teamName,
                        expensed_meals_active: hasExpensedMealsForSelectedAccount,
                        dashpass_for_work_active: hasDashPassForSelectedAccount,
                        countryCode: teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.countryCode,
                        teamAccountPlan: teamAccountPlan,
                    },
                });
            }
            this.initialized = true;
            this.consumerId = consumerId;
            this.teamAccountId = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.id;
            this.teamId = teamId;
            this.teamAccountPlan = teamAccountPlan;
        }
    };
    return PendoUtil;
}());
var pendoUtil = new PendoUtil();
export default pendoUtil;
